import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import TextField from "@material-ui/core/TextField";
import { FileUpload } from "primereact/fileupload";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import { categoryActions } from "../../actions";
import tableRequest from "../../models/tableRequest";
// import { userTypeMasterActions } from '../../actions';
import Switch from "@material-ui/core/Switch";

class categoryMaster extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    this.switchToggleConfirm = this.switchToggleConfirm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
    this.photoBodyTemplate = this.photoBodyTemplate.bind(this);
    this.setImagePath = this.setImagePath.bind(this);

    this.state = {
      IsAdd: true,
      IsEdit: true,
      first: 0,
      rows: 5,
      sliderImages: [],
      totalRecords: 0,
      globalFilter: null,
      sortOrder: "",
      buttonLabel: "Submit",
      switchAction: false,
      formHeading: "Create Ticket",
      CategoryId: 0,
      description: "",
      title: "",
      IsActive: true,
      getUserid:0,
      CreatedDate: null,
      UpdatedDate: null,
      images: [],
      formError: {
        title: "",
        description: "",
        sliderImage: [],
      },
    };
  }

  uploadFiles(e) {
    e.preventDefault();
    //console.log(this.state.file)
  }

  componentDidMount() {

    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);

      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false,
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false,
          });
        } else {
          this.setState({
            IsAdd: true,
          });
        }
      }
    }
    this.state.getUserid=(sessionStorage.getItem("UserData"));
       
    this.props.fetchApi(this.tblResponse);

   
    
    // this.props.getRoleDDL(userId);
  }
  photoBodyTemplate(e) {
    if (e.SliderImage) {
      return <img src={e.SliderImage} width="50px" />;
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.CategoryData) {
      ;
      if (prevProps.CategoryData !== this.props.CategoryData) {
        // this.props.myProp has a different value
        if (this.props.CategoryData) {
          var e = this.props.CategoryData;
          this.setState({
            totalRecords: e[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }
  }

  switchToggleConfirm = (e) => {
    const formData = {
      CategoryId: this.state.CategoryId,
      CategoryName: this.state.CategoryName,
      IsActive: this.state.switchAction,
    };
    this.props.updateCategory(formData);
    //this.props.inActiveRow(this.state.CategoryId, this.state.switchAction);
  };

  handleChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    switch (name) {
      case "IsActive":
        value = event.target.checked;
        break;
      default:
        break;
    }
    this.validateForm(value, name);
    this.setState({ errors, [name]: value });
  }

  UpdatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
  }

  CreatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
  }
  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    switch (name) {
      case "title":
        if (value.length < 1) {
          IsValid = false;
          errors.title = "Please enter Subject ";
        } else errors.title = "";
        break;
      case "description":
        if (value.length < 1) {
          IsValid = false;
          errors.title = "Please enter Description ";
        } else errors.title = "";
        break;
      default:
        break;
    }

    return IsValid;
  }

  submitForm(event) {
    
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = this.state.formError;

    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.validateForm(val, key);
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      debugger
      const formData = {
        ticketId: this.state.ticketId,
        title: this.state.title,
        description: this.state.description,
        IsActive: this.state.IsActive,
        UserId:this.state.getUserid,
        status: 'Open',
      };

      if (formData.ticketId > 0) {
        this.props.updateCategory(formData, this.tblResponse);
      } else {
        this.props.createCategory(formData, this.tblResponse);
      }
      if (!this.props.showDialog) {
        this.resetForm();
      }
    }
  }

  // getRoleDDL(event) {
  //     this.props.getRoleDDL();
  // }
  resetForm() {
    this.setState({
      ticketId: 0,
      title: "",
      description: "",
      IsActive: true,
      formError: {
        title: "",
        description: "",
      },
    });

    let errors = this.state.formError;
    Object.entries(errors).map(([key]) => {
      errors[key] = "";
      return errors[key];
    });
  }

  //to lazy load
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  onPage(event) {
    this.props.loadingData(true);

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }

  //to search
  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
  }

  onHide() {
    this.props.onHideShow(false);
    this.resetForm();
  }
  openDialog() {
    this.props.onHideShow(true);
    this.setState({ buttonLabel: "Submit", formHeading: "Create Ticket" });
  }
  statusBodyTemplate(rowData) {
    if (rowData) {
      return (
        <Checkbox
          disabled
          checked={rowData.IsActive}
          color="primary"
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      );
    }
  }

  fileSelectedHandler = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      const newImages = [...this.state.images];
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          newImages.push(e.target.result);
          this.setState({ images: newImages });
        };
        reader.readAsDataURL(file);
      });
    }
  };

  removeImage = (index) => {
    this.setState((prevState) => ({
      sliderImages: prevState.sliderImages.filter((_, i) => i !== index) // Remove by index
    }));
  };

  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }
  actionBodyTemplate(rowData) {
    ;
    const editMode = (e) => {
      this.props.onHideShow(true);
      this.setState({
        buttonLabel: "Update",
        formHeading: "Update Ticket",
        CategoryId: rowData.CategoryId == null ? 0 : rowData.CategoryId,
        CategoryName: rowData.CategoryName,
        IsActive: rowData.IsActive,
        CreatedDate: rowData.CreatedDate,
        sliderImage: rowData.FilePath,
      });
    };
    const switchHandleChange = (e) => {
      this.setState({
        switchAction: !rowData.IsActive,
        CategoryId: rowData.CategoryId,
        CategoryName: rowData.CategoryName,
      });
      this.props.onHideShowIsActive(true);
    };

    if (rowData) {
      return (
        <>
          {this.state.IsEdit === true ? (
            <div>
              {/* <Switch
                checked={rowData.IsActive}
                color="primary"
                name={rowData.CategoryId}
                onChange={switchHandleChange}
                inputProps={{ "aria-label": "secondary checkbox" }}
              /> */}
              <Button icon="pi pi-eye" onClick={editMode} />
            </div>
          ) : (
            ""
          )}
        </>
      );
    }
  }
  // set Slider Image Path
  setImagePath = (event) => {
    let errors = this.state.formError;
    errors.sliderImage = "";

    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState((prevState) => ({
            sliderImages: [...prevState.sliderImages, response.Source], // Append new image URL
          }));
        } else if (response.ResponseCode === "400") {
          errors.sliderImage = "Only image format is accepted.";
        }
      }
    }
  };


  render() {
    const renderFooter = (name) => {
      return (
        <div>
          <Button
            label="No"
            icon="pi pi-times"
            onClick={() => this.props.onHideShowIsActive(false)}
            className="p-button-text"
          />
          <Button
            label="Yes"
            icon="pi pi-check"
            onClick={this.switchToggleConfirm}
            autoFocus
          />
        </div>
      );
    };
    const header = (
      <div className="table-header row">
        <div className="col-md-6">
          <h4>Ticket</h4>
        </div>
        <div className="col-md-6 text-right">
          <span className="p-input-icon-left mr-2">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={(e) => this.searchFilter(e)}
              placeholder="Global Search"
            />
          </span>

          {this.state.IsAdd === true ? (
            <Button
              className="mr-2"
              label="Create Ticket"
              icon="pi pi-plus-circle"
              onClick={this.openDialog}
            />
          ) : (
            <Button
              className="mr-2"
              label="Create Ticket"
              icon="pi pi-plus-circle"
              style={{ display: "none" }}
              onClick={this.openDialog}
            />
          )}
        </div>
      </div>
    );

    return (
      <div className="datatable-filter-demo">
        <ToastContainer />

        <div className="card">
          <DataTable
            value={this.props.CategoryData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="TicketId"
              header="Ticket No"
              sortable
            ></Column>

<Column
              field="Title"
              header="Subject"
              sortable
            ></Column>

<Column
              field="Description"
              header="Description"
              sortable
            ></Column>

            {/* <Column field="CreatedDate" header="Created Date" sortable></Column> */}
            {this.state.IsEdit === true ? (
              <Column
                field="Action"
                header="Action"
                style={{ width: "130px" }}
                body={this.actionBodyTemplate}
              ></Column>
            ) : (
              <Column
                field="Action"
                header="Action"
                style={{ width: "130px", display: "none" }}
              ></Column>
            )}
          </DataTable>
        </div>
        <Dialog
          header={this.state.formHeading}
          modal
          dismissableMask={false}
          visible={this.props.showDialog}
          className="popup"
          onHide={this.onHide}
        >
          {/* <form onSubmit={this.submitForm} autocomplete="off">
            <div className="row">
              <div className="fileslider col-md-4 col-xl-4">
                                <FileUpload
                                    name="sliderImage"
                                    mode="basic"
                                    url={process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"}
                                    auto={true}
                                    onUpload={this.setImagePath}
                                    onChange={this.fileSelectedHandler}
                                    onError={this.onErrorImage}
                                    multiple accept={this.state.SliderUploadType}
                                />


                                   </div>
              <div className="fileslider col-md-4 col-xl-4">
                                <TextField id="standard-basic" size="small" onChange={this.handleChange} value={this.state.sliderImage} name="shareurl" variant="outlined" className="width" label="File Url : " />
                                <div className="blockimgprive">
                                    {this.state.sliderImage ? (
                                        <div className="p-fileupload-content mt-3 p-1">
                                            <div>
                                                <img
                                                    alt=" "
                                                    role="presentation"
                                                    src={this.state.sliderImage}
                                                    width="80"
                                                    height="60"
                                                />
                                            </div>
                                        </div>
                                    ) : null}

                                    {this.state.formError.sliderImage !== null ? (
                                        <div className="error">
                                            {this.state.formError.sliderImage}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
            </div>

            <div className="row">
              <div className="col-md-4 pt-3">
                <TextField
                  onChange={this.handleChange}
                  name="CategoryName"
                  autoComplete="false"
                  value={this.state.CategoryName}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Category Name*"
                />
                {this.state.formError.CategoryName !== "" ? (
                  <div className="error">
                    {this.state.formError.CategoryName}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-4 pt-3">
                <Checkbox
                  name="IsActive"
                  checked={this.state.IsActive}
                  onClick={this.handleChange}
                  color="primary"
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />{" "}
                <label>Is Active</label>
              </div>
              <div className="col-md-4 mt-3 mb-3 text-center">
                {this.state.IsEdit === true ? (
                  <Button label={this.state.buttonLabel} icon="pi pi-check" />
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-12">
                Note: Fields marked as (*) are required
              </div>
            </div>
          </form> */}

          <form onSubmit={this.submitForm} autoComplete="off">


            <div className="row">
              <div className="col-md-4 pt-3">
                <TextField
                  onChange={this.handleChange}
                  name="title"
                  value={this.state.title}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Subject"
                />
              </div>
              <div className="col-md-4 pt-3">
                <TextField
                  onChange={this.handleChange}
                  name="description"
                  value={this.state.description}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Description"
                />
              </div>

              <div hidden className="col-md-4 pt-3">
                <Checkbox
                  name="IsActive"
                  checked={this.state.IsActive}
                  onClick={() => this.setState({ IsActive: !this.state.IsActive })}
                  color="primary"
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
                <label>Is Active</label>
              </div>

              <div className="row">
                <div className="fileslider col-md-4 col-xl-4">
                  <FileUpload
                    name="sliderImage"
                    mode="basic"
                    url={process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"}
                    auto={true}
                    onUpload={this.setImagePath}
                    multiple // Allow multiple files
                    accept="image/*"
                  />
                </div>

                <div className="fileslider col-md-4 col-xl-4">
                  <TextField
                    id="standard-basic"
                    size="small"
                    hidden
                    value={this.state.sliderImages.join(", ")} // Show all URLs as a list
                    name="shareurl"
                    variant="outlined"
                    className="width"
                    label="File URLs"
                    disabled
                  />
                </div>
              </div>
              <div className="blockimgprive mt-3 d-flex flex-wrap">
                {this.state.sliderImages.length > 0 &&
                  this.state.sliderImages.map((img, index) => (
                    <div key={index} className="uploaded-img-container">

                      <div style={{ width: 100 }}>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm ml-2"
                          onClick={() => this.removeImage(index)}
                        >
                          ✖
                        </button>
                        <img src={img} alt="Uploaded" className="uploaded-img" />
                      </div>

                    </div>
                  ))}
              </div>
              <div className="col-md-4 mt-3 mb-3 text-center">
                <Button type="submit" label="Submit" icon="pi pi-check" />
              </div>


            </div>

          </form>



        </Dialog>
        <Dialog
          header="Confirmation"
          visible={this.props.showIsActiveDialog}
          modal
          style={{ width: "350px" }}
          footer={renderFooter("displayConfirmation")}
          onHide={() => this.props.onHideShowIsActive(false)}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3 confirm-icon"
              style={{ fontSize: "2rem" }}
            />
            <span>
              Are you sure you want to{" "}
              {this.state.switchAction == true ? "Active" : "InActive"}?
            </span>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    CategoryData: state.category.items,
    showDialog: state.category.showDialog,
    loading: state.category.loding,
    showIsActiveDialog: state.category.showIsActiveDialog,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(categoryActions.getAll(obj));
    },
    createCategory: (category, obj) =>
      dispatch(categoryActions.createCatagory(category, obj)),
    updateCategory: (category, obj) =>
      dispatch(categoryActions.updateCategory(category, obj)),
    inActiveRow: (category, isActive) =>
      dispatch(categoryActions.inActiveRow(category, isActive)),
    onHideShow: (isbool) => dispatch(categoryActions.onHideShow(isbool)),
    onHideShowIsActive: (isbool) =>
      dispatch(categoryActions.onHideShowIsActive(isbool)),
    loadingData: (isLoding) => dispatch(categoryActions.loadingData(isLoding)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(categoryMaster);
